import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart, faBell, faBars } from "@fortawesome/free-solid-svg-icons";
import SearchBar from "./Searchbar";

const MobileHeader = ({
	isAuthenticated,
	cartCount,
	unreadCount,
	notifications,
	setIsSidebarOpen,
	setIsNotifDropdownOpen,
	onSearchSubmit,
	navigate,
	onClearAll,
	onRemoveOne,
	onSeeAll
}) => {
	const notifDropdownRef = useRef(null);

	const toggleNotifDropdown = () => {
		setIsNotifDropdownOpen(prev => !prev);
	};

	return (
		<div className="lg:hidden bg-[#FDFBF7] border-b border-stone-200 relative z-50">
			{/* Micro wood grain texture for that tactile artisan feel */}
			<div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/pinstriped-suit.png')]"></div>

			<div className="container mx-auto relative z-10">
				<div className="flex justify-between items-center p-4">
					{/* Logo */}
					<div
						className="flex items-center space-x-2 cursor-pointer"
						onClick={() => navigate("/")}
					>
						<img src="/assets/zakkuu logo bg.png" alt="Logo" className="h-9" />
					</div>

					{/* Right Side Icons */}
					<div className="flex items-center space-x-5">
						{isAuthenticated && (
							<>
								{/* Cart */}
								<div className="relative" title="Cart">
									<Link to="/cart" className="text-stone-600 active:text-[#7A5C33]">
										<FontAwesomeIcon icon={faShoppingCart} size="lg" />
										{cartCount > 0 && (
											<span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-4 h-4 text-[9px] font-bold text-white bg-[#7A5C33] rounded-full shadow-sm">
												{cartCount}
											</span>
										)}
									</Link>
								</div>

								{/* Notifications */}
								<div className="relative" ref={notifDropdownRef} title="Notifications">
									<button onClick={toggleNotifDropdown} className="text-stone-600 active:text-[#7A5C33] outline-none">
										<FontAwesomeIcon icon={faBell} size="lg" />
										{unreadCount > 0 && (
											<span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-4 h-4 text-[9px] font-bold text-white bg-[#A38A64] rounded-full shadow-sm">
												{unreadCount}
											</span>
										)}
									</button>
								</div>
							</>
						)}

						{/* Mobile Menu Toggle - Chiseled Artisan Style */}
						<button
							onClick={() => setIsSidebarOpen(true)}
							className="w-10 h-10 flex items-center justify-center border border-stone-200 bg-white text-stone-800 shadow-sm active:bg-stone-50"
						>
							<FontAwesomeIcon icon={faBars} />
						</button>
					</div>
				</div>

				{/* Mobile Search Bar - Wrapped in a warm container */}
				<div className="px-4 pb-4">
					<SearchBar isMobile={true} onSearchSubmit={onSearchSubmit} />
				</div>
			</div>
		</div>
	);
};

export default MobileHeader;
